module.exports = __webpack_public_path__ + "img/m-logo@2x.49392de3.png";